<template>
  <div class="designerpage">
    <solarcalibre-designer-question-door-range :fabricator="fabricator"
                                               v-model:target="door.attr.door_range"
                                               :ranges="ranges"
                                               title="Choose Door Range"
                                               :defaults="defaults()"
                                               :reference_on="reference_on"></solarcalibre-designer-question-door-range>

    <designer-question-select-door :fabricator="fabricator"
                                   :secured-by-design="door.attr.secured_by_design"
                                   :door-range="door.attr.door_range"
                                   v-model:target="door.attr.slab"></designer-question-select-door>

    <div class="designeroption" v-if="is_timber">
      <synseal-designer-question-frame-material :slab="door.attr.slab"
                                                :fabricator="fabricator"
                                                :door-range="door.attr.door_range"
                                                v-model:target="door.attr.frame_material"></synseal-designer-question-frame-material>
    </div>


    <synseal-designer-question-select-frame-style :fabricator="fabricator"
                                                  :material="door.attr.frame_material"
                                                  v-model:target="door.attr.frame_style"></synseal-designer-question-select-frame-style>

    <div class="designeroption">
      <synseal-designer-question-hinge-side :fabricator="fabricator"
                                            v-model:target="door.attr.hinge_side"></synseal-designer-question-hinge-side>

      <synseal-designer-question-opening-direction :fabricator="fabricator"
                                                   :frame-combination="door.attr.frame_style.frame_id"
                                                   v-model:target="door.attr.opening_direction"></synseal-designer-question-opening-direction>
    </div>

    <div class="designeroption" data-designer-component-id="door_colour">
      <h3>Door Colour</h3>

      <div class="colourtabs">
        <ul>
          <li><a href="#dc-tabs-1">External Colour</a></li>
          <li><a href="#dc-tabs-2">Internal Colour</a></li>
        </ul>
        <div id="dc-tabs-1">
          <synseal-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :is-craftsman="is_timber"
                                                          v-model:target="door.attr.external_colour"></synseal-designer-question-door-colour-external>
        </div>
        <div id="dc-tabs-2">
          <synseal-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                          :external-colour="door.attr.external_colour"
                                                          :frame-material="door.attr.frame_material"
                                                          :is-craftsman="is_timber"
                                                          v-model:target="door.attr.door_colour_internal"></synseal-designer-question-door-colour-internal>
        </div>
      </div>
    </div>

    <div class="designeroption" data-designer-component-id="frame_colour">
      <h3>Frame Colour</h3>

      <div class="colourtabs">
        <ul>
          <li><a href="#tabs-1">External Colour</a></li>
          <li><a href="#tabs-2">Internal Colour</a></li>
        </ul>
        <div id="tabs-1">
          <synseal-designer-question-frame-colour-external :fabricator="fabricator"
                                                           :door-colour="door.attr.external_colour"
                                                           :slab="door.attr.slab"
                                                           :frame-material="door.attr.frame_material"
                                                           :profile="door.attr.profile"
                                                           v-model:target="door.attr.frame_colour_external"></synseal-designer-question-frame-colour-external>
        </div>
        <div id="tabs-2">
          <synseal-designer-question-frame-colour-internal :fabricator="fabricator"
                                                           :frame-material="door.attr.frame_material"
                                                           :slab="door.attr.slab"
                                                           :frame-colour-external="door.attr.frame_colour_external"
                                                           :profile="door.attr.profile"
                                                           v-model:target="door.attr.frame_colour_internal"></synseal-designer-question-frame-colour-internal>
        </div>
      </div>
    </div>

    <div v-show="technical_should_show">
      <solarcalibre-designer-question-secured-by-design :fabricator="fabricator"
                                                        :slab="door.attr.slab"
                                                        v-model:target="door.attr.secured_by_design"></solarcalibre-designer-question-secured-by-design>
    </div>

    <div class="designeroption" v-show="technical_should_show">
      <synseal-designer-question-door-glass-laminated :fabricator="fabricator"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :slab="door.attr.slab"
                                                      :side-panels="door.attr.side_panels"
                                                      :frame-style="door.attr.frame_style"
                                                      v-model:target="door.attr.laminated_glass"></synseal-designer-question-door-glass-laminated>
    </div>

    <div class="designeroption">
      <synseal-designer-question-glass-design :fabricator="fabricator"
                                              v-model:target="door.attr.glass_design"
                                              :laminated-glass="door.attr.laminated_glass"
                                              :door-range="door.attr.door_range"
                                              :slab="door.attr.slab"></synseal-designer-question-glass-design>
    </div>

    <synseal-designer-question-glass-backing-design :fabricator="fabricator"
                                                    v-model:target="door.attr.glass_backing_design"
                                                    :slab="door.attr.slab"
                                                    :glass-design="door.attr.glass_design"></synseal-designer-question-glass-backing-design>

    <solarcalibre-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                            v-model:target="door.attr.side_panels"
                                                            :door-range="door.attr.door_range"
                                                            :frame-style="door.attr.frame_style"
                                                            :frame-profile="door.attr.profile"
                                                            :frame-material="door.attr.frame_material"
                                                            :laminated-glass="door.attr.laminated_glass"
                                                            :frame-colour-internal="door.attr.frame_colour_internal"
                                                            :frame-colour-external="door.attr.frame_colour_external"
                                                            :secured-by-design="door.attr.secured_by_design"
                                                            :measurements.sync="door.attr.measurements"
                                                            :slab="door.attr.slab"
                                                            :type-range="door.attr.door_range"
                                                            :is_timber="is_timber"></solarcalibre-designer-question-select-frame-sidepanels>

    <designer-question-hardware-suite-selector
      v-if="hardware_suite_required"
      suites="84,58"
      :fabricator="fabricator"
      v-model:target="door.attr.suite"
      :door-range="door.attr.door_range"
      :slab="door.attr.slab"
      :secured-by-design="door.attr.secured_by_design"
      :opening-direction="door.attr.opening_direction"
      :profile="door.attr.profile"
    ></designer-question-hardware-suite-selector>

    <wb-designer-question-hardware-colour-with-suite
      :fabricator="fabricator"
      v-model:target="door.attr.hardware_colour"
      :sbd="door.attr.secured_by_design"
      :slab="door.attr.slab"
      :hardware-suite="door.attr.suite"
      :door-range="door.attr.door_range"
      :profile="door.attr.profile"
      :opening-direction="door.attr.opening_direction"
    ></wb-designer-question-hardware-colour-with-suite>

    <designer-question-hardware-handle-with-suite
      :fabricator="fabricator"
      v-model:target="door.attr.hardware_handle"
      :slab="door.attr.slab"
      :secured-by-design="door.attr.secured_by_design"
      :opening-direction="door.attr.opening_direction"
      :hardware-colour="door.attr.hardware_colour"
      :hardware-suite="door.attr.suite"
      :door-range="door.attr.door_range"
      :profile="door.attr.profile"
    ></designer-question-hardware-handle-with-suite>

    <div class="designeroption" data-designer-component-id="split_spindle" v-show="technical_should_show">
      <synseal-designer-question-hardware-handle-split-spindle :fabricator="fabricator"
                                                               v-model:target="door.attr.hardware_handle_split_spindle"
                                                               :hardware-handle="door.attr.hardware_handle"
                                                               :slab="door.attr.slab"></synseal-designer-question-hardware-handle-split-spindle>
    </div>

    <synseal-designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_decorative_handle"
                                                          :slab="door.attr.slab"
                                                          :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"></synseal-designer-question-hardware-decorative-handle>
    <synseal-designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                   v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                   :slab="door.attr.slab"
                                                                   :frame-material="door.attr.frame_material"
                                                                   :hardware-decorative-handle="door.attr.hardware_decorative_handle"></synseal-designer-question-hardware-decorative-handle-position>

    <synseal-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_escutcheon"
                                                   :slab="door.attr.slab"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :door-range="door.attr.door_range"
                                                   :profile="door.attr.profile"></synseal-designer-question-hardware-escutcheon>
    <synseal-designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></synseal-designer-question-hardware-escutcheon-position>

    <div class="designeroption">
      <h3>Lock Options</h3>
      <synseal-designer-question-hardware-lock :fabricator="fabricator"
                                               v-model:target="door.attr.hardware_lock"
                                               :secured-by-design="door.attr.secured_by_design"
                                               :hinge-side="door.attr.hinge_side"
                                               :slab="door.attr.slab"
                                               :frame-material="door.attr.frame_material"
                                               :hardware-handle="door.attr.hardware_handle"
                                               :opening_direction="door.attr.opening_direction"
                                               :hardware-escutcheon="door.attr.hardware_escutcheon"
                                               :door-range="door.attr.door_range"></synseal-designer-question-hardware-lock>

      <synseal-designer-question-hardware-cylinder :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_cylinder"
                                                   :slab="door.attr.slab"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :hardware-lock="door.attr.hardware_lock"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :opening_direction="door.attr.opening_direction"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :door-range="door.attr.door_range"></synseal-designer-question-hardware-cylinder>
    </div>
    <div class="designeroption">
      <synseal-designer-question-hardware-hinge :fabricator="fabricator"
                                                v-model:target="door.attr.hardware_hinge"
                                                :slab="door.attr.slab"
                                                :opening_direction="door.attr.opening_direction"
                                                :secured-by-design="door.attr.secured_by_design"
                                                :hardware-colour="door.attr.hardware_colour"
                                                :hinge-side="door.attr.hinge_side"
                                                :frame-material="door.attr.frame_material"
                                                :door-range="door.attr.door_range"></synseal-designer-question-hardware-hinge>
    </div>
    <div class="designeroption">
      <synseal-designer-question-hardware-security-chain :fabricator="fabricator"
                                                         :secured-by-design="door.attr.secured_by_design"
                                                         v-model:target="door.attr.hardware_security_chain"
                                                         :hardware-colour="door.attr.hardware_colour"
                                                         :door-range="door.attr.door_range"></synseal-designer-question-hardware-security-chain>
    </div>

    <div class="designeroption">
      <synseal-designer-question-hardware-letterbox :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_letterbox"
                                                    :slab="door.attr.slab"
                                                    :side-panels="door.attr.side_panels"
                                                    :frame-id="door.attr.frame_style.frame_id"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"
                                                    :secured-by-design="door.attr.secured_by_design"
      ></synseal-designer-question-hardware-letterbox>

      <synseal-designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_letterbox_pos"
                                                             :slab="door.attr.slab"
                                                             :side-panels="door.attr.side_panels"
                                                             :frame-id="door.attr.frame_style.frame_id"
                                                             :frame-material="door.attr.frame_material"
                                                             :hardware-letterbox="door.attr.hardware_letterbox"
      ></synseal-designer-question-hardware-letterbox-position>
    </div>

    <div class="designeroption">
      <synseal-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_spy_hole"
                                                   :slab="door.attr.slab"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :glass-design="door.attr.glass_design"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-knocker="door.attr.hardware_knocker"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></synseal-designer-question-hardware-spy-hole>
      <synseal-designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_spy_hole_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-spy-hole="door.attr.hardware_spy_hole"></synseal-designer-question-hardware-spy-hole-position>
    </div>

    <div class="designeroption">
      <synseal-designer-question-hardware-knocker :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_knocker"
                                                  :slab="door.attr.slab"
                                                  :hardware-handle="door.attr.hardware_handle"
                                                  :hardware-spyhole="door.attr.hardware_spy_hole"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"></synseal-designer-question-hardware-knocker>
      <synseal-designer-question-hardware-knocker-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_knocker_pos"
                                                           :slab="door.attr.slab"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-knocker="door.attr.hardware_knocker"></synseal-designer-question-hardware-knocker-position>
    </div>

    <div class="designeroption" data-designer-component-id="numerals">
      <synseal-designer-question-hardware-numerals :fabricator="fabricator"
                                                   v-model:target="door.attr.numerals"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   title="Numerals"></synseal-designer-question-hardware-numerals>
    </div>

    <div class="designeroption" v-show="technical_should_show">
      <synseal-designer-question-technical-profile :fabricator="fabricator"
                                                   :frame-material="door.attr.frame_material"
                                                   :frame-colour-internal="door.attr.frame_colour_internal"
                                                   :frame-colour-external="door.attr.frame_colour_external"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                   :opening-direction="door.attr.opening_direction"
                                                   v-model:target="door.attr.profile"
                                                   :maintitle="'Select Profile'"
      ></synseal-designer-question-technical-profile>
    </div>

    <div class="designeroption" v-show="technical_should_show">
      <synseal-designer-question-addons :fabricator="fabricator"
                                        title="Add Ons - All Add on's are inclusive of the overall width and height inputted"
                                        v-model:target="door.attr.addons"
                                        :frame-profile="door.attr.profile"
                                        :frame-colour-internal="door.attr.frame_colour_internal"
                                        :frame-colour-external="door.attr.frame_colour_external">

      </synseal-designer-question-addons>
    </div>
    <div class="designeroption" v-show="technical_should_show">
      <h3> Sill </h3>
      <designer-question-technical-cill
        :fabricator="fabricator"
        v-model:target="door.attr.cill"
        :frame-colour-internal="door.attr.frame_colour_internal"
        :frame-colour-external="door.attr.frame_colour_external"
        :opening-direction="door.attr.opening_direction"
        :frame-profile="door.attr.profile"
        :threshold="door.attr.threshold"
        :component_id="'cill'"
        title=""
        :show_cill_horn_text="false"
      ></designer-question-technical-cill>

      <!--
                  <synseal-designer-question-sill-colour v-if="sill_measure" :fabricator="fabricator"
                                                         title="Sill Colour"
                                                         :frame-colour-external="door.attr.frame_colour_external"
                                                         v-model:target="door.attr.sill_colour"></synseal-designer-question-sill-colour>
      -->

      <designer-question-technical-cill-measure v-if="sill_measure" :fabricator="fabricator"
                                                v-model:target="door.attr.cill_measure"
                                                title="Sill Length (mm)"
                                                :cill="door.attr.cill"></designer-question-technical-cill-measure>

      <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                        v-model:target="door.attr.side_panels.left_flag_sill_id"
                                        :frame-colour-internal="door.attr.frame_colour_internal"
                                        :frame-colour-external="door.attr.frame_colour_external"
                                        :frame-profile="door.attr.profile"
                                        :title="'Left Sidepanel Flag'"
                                        :component_id="'left_flag_cill'"
      ></designer-question-technical-cill>

      <designer-question-technical-cill-measure v-if="left_flag_sill && left_sill_measure"
                                                :fabricator="fabricator"
                                                v-model:target="door.attr.left_flag_cill_measure"
                                                title="Left Sidepanel Flag Sill Length (mm)"
                                                :cill="door.attr.cill"></designer-question-technical-cill-measure>

      <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                        v-model:target="door.attr.side_panels.right_flag_sill_id"
                                        :frame-colour-internal="door.attr.frame_colour_internal"
                                        :frame-colour-external="door.attr.frame_colour_external"
                                        :frame-profile="door.attr.profile"
                                        :title="'Right Sidepanel Flag'"
                                        :component_id="'right_flag_cill'"
      ></designer-question-technical-cill>

      <designer-question-technical-cill-measure v-if="right_flag_sill && right_sill_measure"
                                                :fabricator="fabricator"
                                                v-model:target="door.attr.right_flag_cill_measure"
                                                title="Right Sidepanel Flag Sill Length (mm)"
                                                :cill="door.attr.cill"></designer-question-technical-cill-measure>


    </div>

    <div class="designeroption" v-show="technical_should_show" data-designer-component-id="door_drip_colour">
      <synseal-designer-question-door-drip-colour :fabricator="fabricator"
                                                  :external-colour="door.attr.external_colour"
                                                  v-model:target="door.attr.door_drip_colour"
                                                  :frame-profile="door.attr.profile"
                                                  :door-range="door.attr.door_range"
                                                  maintitle="Door Drip Colour"
      ></synseal-designer-question-door-drip-colour>
    </div>

    <div class="designeroption" v-show="technical_should_show" data-designer-component-id="threshold">
      <synseal-designer-question-technical-threshold :fabricator="fabricator"
                                                     v-model:target="door.attr.threshold"
                                                     :opening-direction="door.attr.opening_direction"
                                                     :frame-profile="door.attr.profile"
                                                     :cill="door.attr.cill"
                                                     modifier_class="_wide"
                                                     :title="'Threshold'"
                                                     :door-range="door.attr.door_range"></synseal-designer-question-technical-threshold>
    </div>

    <div class="row" v-show="technical_should_show">
      <div class="col-sm">
        <designer-question-door-ramp title="External Ramp"
                                     v-model:target="door.attr.ramp.external"
                                     :fabricator="fabricator"
                                     :frame="door.attr.profile"
                                     :threshold="door.attr.threshold"
                                     :cill="door.attr.cill"
                                     :component_id="'ramp_external'">
        </designer-question-door-ramp>
      </div>
      <div class="col-sm">
        <designer-question-door-ramp title="Internal Ramp"
                                     v-model:target="door.attr.ramp.internal"
                                     :fabricator="fabricator"
                                     :frame="door.attr.profile"
                                     :threshold="door.attr.threshold"
                                     :cill="door.attr.cill"
                                     :component_id="'ramp_internal'">
        </designer-question-door-ramp>
      </div>
    </div>

    <div class="designeroption" v-show="technical_should_show">
      <solarcalibre-designer-question-technical-drainage :fabricator="fabricator"
                                                         v-model:target="door.attr.drainage"
                                                         :cill="door.attr.cill"
                                                         :threshold="door.attr.threshold"
                                                         maintitle="Drainage"
                                                         title=""
                                                         :type-range="door.attr.door_range"></solarcalibre-designer-question-technical-drainage>
    </div>

    <div class="designeroption" data-designer-component-id="measurements" v-show="technical_should_show">
      <synseal-designer-question-measurements title="Measurements Section"
                                              :fabricator="fabricator"
                                              :slab="door.attr.slab"
                                              :external-colour="door.attr.external_colour"
                                              :internal-colour="door.attr.door_colour_internal"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :frame-id="door.attr.frame_style.frame_id"
                                              :side-panels="door.attr.side_panels"
                                              :addons="door.attr.addons"
                                              :cill="door.attr.cill"
                                              :hardware-lock="door.attr.hardware_lock"
                                              :hardware-hinge="door.attr.hardware_hinge"
                                              :hardware-handle="door.attr.hardware_handle"
                                              :hardware-knocker="door.attr.hardware_knocker"
                                              :hardware-spy-hole="door.attr.hardware_spy_hole"
                                              :hardware-escutcheon="door.attr.hardware_escutcheon"
                                              :hardware-letterbox="door.attr.hardware_letterbox"
                                              :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                              :mdd="mdd"
                                              :technical_should_show="technical_should_show"
                                              v-model:target="door.attr.measurements"></synseal-designer-question-measurements>

    </div>
    <div class="designeroption" data-designer-component-id="reference" v-if="reference_on">
      <h3>Door Reference</h3>
      <div class="stylesoption">
        <div class="form-group">
          <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
        </div>
      </div>
    </div>
    <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
           value="Retail Door">


    <div class="designeroption" data-designer-component-id="notes">
      <synseal-designer-question-notes title="Notes"
                                       v-model:target="door.attr.notes"></synseal-designer-question-notes>
    </div>

    <designer-navigation
      v-if="show_navigation"
      :visible_designer_configurator_components="visible_designer_configurator_components"
      transition="designer-navigation"
    ></designer-navigation>

  </div>

</template>

<script type="text/ecmascript-6">
import DoorConfigurator from "../DoorConfigurator.vue";

export default {
  mixins: [
    DoorConfigurator
  ],
  computed: {
    is_standard() {
      return this.door_type == 'standard';
    },
    is_timber() {
      return this.door_type == 'timber-composite';
    },
    sill_measure() {
      return this.door.attr.cill !== 149;
    },
    left_sill_measure() {
      return this.door.attr.side_panels.left_flag_sill_id !== 149;
    },
    right_sill_measure() {
      return this.door.attr.side_panels.right_flag_sill_id !== 149;
    },
    sbd_required() {
      return this.door.attr.door_range === 97 || this.door.attr.door_range === 98;
    },
    hardware_suite_required() {
      return this.door.attr.door_range !== 94 && this.door.attr.door_range !== 95;
    },
  },
  methods: {
    defaults() {
      return {
        94: {
          "attr": {
              "addons": {
                  "left": {},
                  "right": {},
                  "top": {},
                  "bottom": {},
              },
            "cill": 149,
            "drainage": 1,
            "door_range": 94,
            "door_colour_internal": 1,
            "external_colour": 1,
            "fabricator": 24,
            "frame_colour_external": 1,
            "frame_colour_internal": 1,
            "frame_material": 1,
            "frame_style": {"frame_id": 1, "checkedPanels": []},
            "glass_design": 1,
            "glass_text": "",
            "suite": 58,
            "hardware_colour": 22,
            "hardware_handle": 3396,
            "hardware_hinge": 2969,
            "hinge_side": 1,
            "laminated_glass": 1,
            "hardware_cylinder": 320,
            "hardware_decorative_handle_pos": 2345,
            "hardware_escutcheon_pos": 112,
            "hardware_letterbox": 318,
            "hardware_lock": 229,
            "hardware_knocker": 315,
            "hardware_security_chain": 317,
            "hardware_spy_hole": 316,
            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
            "notes": "",
            "numerals": [326, 326, 326, 326],
            "opening_direction": 1,
            "profile": 151,
            "ramp": {"internal": 144614664, "external": 144614664},
            "secured_by_design": 1,
            "side_panels": {
              "left_composite_id": 1423,
              "right_composite_id": 1423,
              "left": 1,
              "right": 1,
              "left_panel_glass_id": 9,
              "right_panel_glass_id": 9,
              "top_panel_glass_id": 9,
              "left_composite_glass_id": 1,
              "right_composite_glass_id": 1,
              "right_flag_sill_id": 149,
              "left_flag_sill_id": 149
            },
            "slab": 1218,
            "threshold": 144612381,
            "door_drip_colour": 1
          }
        },
        95: {
          "attr": {
            "notes": "",
            "frame_material": 1,
            "door_range": 95,
            "fabricator": 24,
            "frame_colour_external": 1,
            "door_colour_internal": 1,
            "external_colour": 1,
            "frame_colour_internal": 1,
            "glass_design": 1,
            "glass_text": "",
            "suite": 58,
            "hardware_colour": 22,
            "hardware_handle": 3396,
            "hardware_hinge": 2969,
            "hinge_side": 1,
            "opening_direction": 1,
            "secured_by_design": 1,
            "slab": 1256,
            "frame_style": {"frame_id": 1, "checkedPanels": []},
            "laminated_glass": 1,
            "hardware_lock": 229,
            "hardware_cylinder": 320,
            "hardware_security_chain": 317,
            "hardware_letterbox": 318,
            "hardware_knocker": 315,
            "hardware_spy_hole": 316,
            "profile": 151,
            "ramp": {"internal": 144614664, "external": 144614664},
            "threshold": 144612381,
            "side_panels": {
              "left_composite_id": 1423,
              "right_composite_id": 1423,
              "left": 1,
              "right": 1,
              "left_panel_glass_id": 9,
              "right_panel_glass_id": 9,
              "top_panel_glass_id": 9,
              "left_composite_glass_id": 1,
              "right_composite_glass_id": 1,
              "right_flag_sill_id": 149,
              "left_flag_sill_id": 149
            },
            "numerals": [326, 326, 326, 326],
            "cill": 149,
            "drainage": 1,
            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
              "addons": {
                  "left": {},
                  "right": {},
                  "top": {},
                  "bottom": {},
              },
            "door_drip_colour": 1,
            "hardware_escutcheon_pos": 420121
          }
        },
        97: {
          "attr": {
            "notes": "",
            "door_range": 97,
            "fabricator": 24,
            "frame_colour_external": 1,
            "frame_material": 1,
            "door_colour_internal": 77,
            "external_colour": 77,
            "frame_colour_internal": 1,
            "glass_design": 1,
            "glass_text": "",
            "suite": 58,
            "hardware_colour": 15,
            "hardware_handle": 404,
            "hardware_hinge": 9,
            "hinge_side": 1,
            "opening_direction": 1,
            "secured_by_design": 1,
            "slab": 50,
            "frame_style": {"frame_id": 1, "checkedPanels": []},
            "laminated_glass": 1,
            "hardware_lock": 1647,
            "hardware_cylinder": 1320,
            "hardware_security_chain": 317,
            "hardware_letterbox": 318,
            "hardware_knocker": 315,
            "hardware_spy_hole": 316,
            "profile": 151,
            "ramp": {"internal": 144614664, "external": 144614664},
            "threshold": 231,
            "side_panels": {
              "left_composite_id": 130,
              "right_composite_id": 130,
              "left": 1,
              "right": 1,
              "left_panel_glass_id": 9,
              "right_panel_glass_id": 9,
              "top_panel_glass_id": 9,
              "left_composite_glass_id": 1,
              "right_composite_glass_id": 1,
              "right_flag_sill_id": 149,
              "left_flag_sill_id": 149
            },
            "numerals": [326, 326, 326, 326],
            "cill": 149,
              "addons": {
                  "left": {},
                  "right": {},
                  "top": {},
                  "bottom": {},
              },
            "drainage": 1,
            "measurements": {
              "overall_width": null,
              "overall_height": null,
              "left_width": null,
              "right_width": null,
              "top_box_drop": null
            },
            "door_drip_colour": 77,
            "hardware_escutcheon": 91,
            "hardware_escutcheon_pos": 324567
          }
        },
        98: {
          "attr": {
            "notes": "",
            "door_range": 98,
            "fabricator": 24,
            "frame_colour_external": 1,
            "frame_material": 1,
            "door_colour_internal": 77,
            "external_colour": 77,
            "frame_colour_internal": 1,
            "glass_design": 1,
            "glass_text": "",
            "suite": 58,
            "hardware_colour": 22,
            "hardware_handle": 1442,
            "hardware_hinge": 9,
            "hinge_side": 1,
            "opening_direction": 1,
            "secured_by_design": 1,
            "slab": 107,
            "frame_style": {"frame_id": 1, "checkedPanels": []},
            "laminated_glass": 1,
            "hardware_lock": 237,
            "hardware_cylinder": 1319,
            "hardware_security_chain": 317,
            "hardware_letterbox": 318,
            "hardware_knocker": 315,
            "hardware_spy_hole": 316,
            "profile": 151,
            "ramp": {"internal": 144614664, "external": 144614664},
            "threshold": 231,
            "side_panels": {
              "left_composite_id": 130,
              "right_composite_id": 130,
              "left": 1,
              "right": 1,
              "left_panel_glass_id": 9,
              "right_panel_glass_id": 9,
              "top_panel_glass_id": 9,
              "left_composite_glass_id": 1,
              "right_composite_glass_id": 1,
              "right_flag_sill_id": 149,
              "left_flag_sill_id": 149
            },
            "numerals": [326, 326, 326, 326],
            "cill": 149,
              "addons": {
                  "left": {},
                  "right": {},
                  "top": {},
                  "bottom": {},
              },
            "drainage": 1,
            "measurements": {
              "overall_width": null,
              "overall_height": null,
              "left_width": null,
              "right_width": null,
              "top_box_drop": null
            },
            "hardware_handle_split_spindle": 424,
            "door_drip_colour": 77
          }
        },
      };
    },
  },
}
</script>
